var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NotificationContainer'),(_vm.loader.blockingLoader)?_c('AppLoading'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath}),_c('portal-target',{attrs:{"name":"modals-container","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }